import React from "react";
import LoginIcon from "@mui/icons-material/Login";
import {
  Button,
  Card,
  CardContent,
  Container,
  Typography,
} from "@mui/material";
import { grey, yellow } from "@mui/material/colors";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import FormLogin from "src/Patient/FormLogin";
import useAuthPatient from "src/Patient/hooks/useAuthPatient";
import ButtonCustom from "src/shared/components/buttons/ButtonCustom";
import { historyRouteState } from "src/store/global/historyState";
import { snackbarState } from "src/store/global/snackbarState";
import { showBannerState } from "src/store/global/bannerShowState";
import AlertCustom from "src/shared/components/alerts/AlertCustom";
import { useTheme } from "@emotion/react";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import useSEO from "src/Hooks/useSEO";

const Login = () => {
  const { catchErrorApi } = useCatchErrorApi();
  const { param, footer } = useParams();
  const actualParam = param || null;
  const actualFooter = footer || null;

  const theme = useTheme();
  // const resetErrorsFormLogin = useResetRecoilState(errorsReservationUserState)
  // const resetFormLogin = useResetRecoilState(valuesFormReservationUserState)
  const { handleLoginUser, loading } = useAuthPatient();
  const setSnackbar = useSetRecoilState(snackbarState);
  const historyRoute = useRecoilValue(historyRouteState);
  const setShowBanner = useSetRecoilState(showBannerState);
  const [resendCodeConfirmation, setResendCodeCondifrmation] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await handleLoginUser();
      setSnackbar({
        openAlert: true,
        severity: "success",
        text: "Su sesión ha sido iniciada correctamente",
        position: {
          vertical: "bottom",
          horizontal: "right",
        },
      });

      //historyRoute.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/paciente/reservas`)
      navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}/paciente/reservas`);
    } catch (error) {
      catchErrorApi(error);
      if (error?.response?.data) {
        if (
          error.response.data.errors[0].message ===
          "La cuenta de usuario no ha sido confirmada"
        ) {
          setResendCodeCondifrmation(true);
        }
      }
    }
  };

  useSEO({ title: "Iniciar sesión" });

  useEffect(() => {
    setShowBanner(false);
    return () => {
      setShowBanner(true);
      // resetErrorsFormLogin()
      // resetFormLogin();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container style={{ maxWidth: 480 }} sx={{ mt: 12}}>
      {resendCodeConfirmation ? (
        <AlertCustom
          severity="warning"
          style={{ backgroundColor: yellow[100] }}
          variant="outlined"
          children={
            <>
              <p>Aún no ha confirmado su cuenta</p>
              <p>
                Presione{" "}
                <Link
                  style={{
                    color: theme.palette.primary.main,
                    fontWeight: "bold",
                  }}
                  to={`${process.env.REACT_APP_ROOT_SERVER_PATH}/resend-code`}
                >
                  aquí
                </Link>{" "}
                para obtener nuevamente un codigo de confirmacion
              </p>
            </>
          }
        />
      ) : null}
      {actualParam === "lab" &&
        (process.env.REACT_APP_SEDE === "Chillán" ||
          process.env.REACT_APP_SEDE === "Talca") && (
          <AlertCustom
            variant="outlined"
            severity="warning"
            message="Si se realizó examen de laboratorio antes del 27.08.2024 ingrese "
            style={{
              marginBottom: 15,
              backgroundColor: yellow[100],
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Link to="https://laboratorio.andessaludchillan.cl/resultados/">
              <span
                style={{
                  color: theme.palette.primary.main,
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                aquí
              </span>
            </Link>
          </AlertCustom>
        )}
      {actualParam === "lab" &&
        (process.env.REACT_APP_SEDE === "Chillán" ||
          process.env.REACT_APP_SEDE === "Talca") && (
          <AlertCustom
            variant="outlined"
            severity="warning"
            message="Si se realizó examen de laboratorio despues del 27.08.2024 ingrese "
            style={{
              marginBottom: 15,
              backgroundColor: yellow[100],
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Link to="https://lab.andessaludchillan.cl/gestionintegrada">
              <span
                style={{
                  color: theme.palette.primary.main,
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                aquí
              </span>
            </Link>
          </AlertCustom>
        )}
      {/* {actualParam === "lab" &&
        process.env.REACT_APP_SEDE === "Puerto Montt" && (
          <AlertCustom
            variant="outlined"
            severity="warning"
            message="Si se realizó examen de laboratorio antes del 19.08.2025 ingrese "
            style={{
              marginBottom: 15,
              backgroundColor: yellow[100],
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Link to="https://lis.andessaludpuertomontt.cl/consultalab/">
              <span
                style={{
                  color: theme.palette.primary.main,
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                aquí
              </span>
            </Link>
          </AlertCustom>
        )} */}
      {actualParam === "lab" &&
        process.env.REACT_APP_SEDE === "Puerto Montt" && (
          <AlertCustom
            variant="outlined"
            severity="warning"
            message="Si se realizó examen de laboratorio despues del 19.08.2025 ingrese "
            style={{
              marginBottom: 15,
              backgroundColor: yellow[100],
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Link to="https://lab.andessaludpuertomontt.cl/gestionintegrada">
              <span
                style={{
                  color: theme.palette.primary.main,
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                aquí
              </span>
            </Link>
          </AlertCustom>
        )}
      {actualParam === "lab" &&
        actualFooter !== "footer" &&
        (process.env.REACT_APP_SEDE === "Chillán" ||
          process.env.REACT_APP_SEDE === "Talca" ||
          process.env.REACT_APP_SEDE === "Puerto Montt") && (
          <>
            <Typography color={grey[700]} fontWeight={700} fontSize={24} pt={2}>
              INICIE SESIÓN
            </Typography>
            <Typography color={grey[400]} fontWeight={700} fontSize={12} pb={2}>
              INGRESE SUS DATOS
            </Typography>

            <Card>
              <CardContent>
                <FormLogin onKeyEnter={handleLogin} />

                <Link to={`${process.env.REACT_APP_ROOT_SERVER_PATH}/forgot`}>
                  <Button
                    variant="text"
                    color="secondary"
                    fullWidth
                    sx={{ mt: 2 }}
                  >
                    ¿Olvidó su contraseña?
                  </Button>
                </Link>
              </CardContent>

              <Box
                sx={{ p: 2 }}
                style={{ borderTop: "1px solid rgb(225 228 230)" }}
              >
                <ButtonCustom
                  color="secondary"
                  loading={loading}
                  text="Iniciar sesión"
                  icon={<LoginIcon />}
                  onClick={handleLogin}
                  style={{ width: "100%", paddingTop: 12, paddingBottom: 12 }}
                />
              </Box>
            </Card>

            <Link to={`${process.env.REACT_APP_ROOT_SERVER_PATH}/register`}>
              <Button variant="text" color="primary" fullWidth sx={{ mt: 2 }}>
                Registrar Cuenta Nueva
              </Button>
            </Link>
          </>
        )}
      {!actualParam && !actualFooter && (
        <>
          <Typography color={grey[700]} fontWeight={700} fontSize={24} pt={2}>
            INICIE SESIÓN
          </Typography>
          <Typography color={grey[400]} fontWeight={700} fontSize={12} pb={2}>
            INGRESE SUS DATOS
          </Typography>

          <Card>
            <CardContent>
              <FormLogin onKeyEnter={handleLogin} />

              <Link to={`${process.env.REACT_APP_ROOT_SERVER_PATH}/forgot`}>
                <Button
                  variant="text"
                  color="secondary"
                  fullWidth
                  sx={{ mt: 2 }}
                >
                  ¿Olvidó su contraseña?
                </Button>
              </Link>
            </CardContent>

            <Box
              sx={{ p: 2 }}
              style={{ borderTop: "1px solid rgb(225 228 230)" }}
            >
              <ButtonCustom
                color="secondary"
                loading={loading}
                text="Iniciar sesión"
                icon={<LoginIcon />}
                onClick={handleLogin}
                style={{ width: "100%", paddingTop: 12, paddingBottom: 12 }}
              />
            </Box>
          </Card>

          <Link to={`${process.env.REACT_APP_ROOT_SERVER_PATH}/register`}>
            <Button variant="text" color="primary" fullWidth sx={{ mt: 2 }}>
              Registrar Cuenta Nueva
            </Button>
          </Link>
        </>
      )}
    </Container>
  );
};

export default Login;
